import { isTranslationId, TranslationId } from '../../transloco';
import { isYattaLinkBase, YattaLinkBase } from './yatta-link-base';

export interface MailtoLink extends YattaLinkBase {
  mailto: string;
  subject: TranslationId;
  body?: TranslationId | null;
  id?: string;
}

export function isMailtoLink(value: unknown): value is MailtoLink {
  return (
    typeof value === 'object' &&
    value !== null &&
    'mailto' in value &&
    typeof value.mailto === 'string' &&
    'subject' in value &&
    isTranslationId(value.subject) &&
    (!('body' in value) || value.body === undefined || value.body === null || isTranslationId(value.body)) &&
    isYattaLinkBase(value)
  );
}

export const buildMailToLink = (mailto: string, subject: TranslationId, body?: TranslationId | null, id?: string): MailtoLink => {
  return {
    mailto,
    subject,
    body,
    id
  };
};
